import { useRef } from "react"

/**
 * Ключ данных, которые реально на экране. Пока запрос идёт с `placeholderData`, на экране
 * прежний список, и ключ остаётся прежним: ключ от фильтра заставил бы список погаснуть и
 * проявиться заново ещё до прихода новых данных.
 */
export function useShownKey(key: string, isPlaceholderData: boolean) {
	const shown = useRef(key)
	if (!isPlaceholderData) shown.current = key
	return shown.current
}

/**
 * Каскад по строкам только на первом показе. Дальше смену данных ведёт перекрёстный переход
 * всего блока, а каскад поверх него растянул бы смену почти на секунду. После первой смены
 * ключа каскад не включается, в том числе при возврате к первому ключу.
 */
export function useIntro(key: string, ready: boolean) {
	const first = useRef<string | null>(null)
	const done = useRef(false)
	if (ready && first.current === null) first.current = key
	if (first.current !== null && key !== first.current) done.current = true
	return !done.current
}
